/** Normaliza o nome gravado em tipoVeiculo.icone (ex.: "motoboy  sem bau.png"). */
export function chaveIconeRastreio(nome) {
	return String(nome || "")
		.trim()
		.toLowerCase()
		.replace(/\.(png|jpe?g|svg|gif|webp)$/i, "")
		.replace(/\s+/g, " ")
		.trim()
}

const COR = "#1a73e8"
const VIDRO = "#e8f0fe"
const VIDRO_TRAS = "#bbdefb"
const PNEU = "#1a1a1a"

function svg(inner) {
	return (
		`<svg class="rs-gps-veic" viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg">` +
		inner +
		`</svg>`
	)
}

function pneu(cx, cy, rx, ry) {
	return `<ellipse cx="${cx}" cy="${cy}" rx="${rx}" ry="${ry}" fill="${PNEU}" stroke="#fff" stroke-width="1.8"/>`
}

function rodaCarro(x, y) {
	return `<rect x="${x}" y="${y}" width="5.2" height="11.5" rx="2.2" fill="${PNEU}" stroke="#fff" stroke-width="1.4"/>`
}

/** Moto vista de cima: frente (guidão) no topo. */
function moto({ bau = false, taxi = false } = {}) {
	return svg(
		pneu(32, 51, 10.5, 8) +
			pneu(32, 14.5, 8.2, 7.6) +
			`<path fill="${COR}" stroke="#fff" stroke-width="2.4" stroke-linejoin="round" ` +
			`d="M26 19c0-5.4 2.6-10.2 6-10.2s6 4.8 6 10.2l2.4 22.4c0 4.6-3.4 8.2-8.4 8.2s-8.4-3.6-8.4-8.2Z"/>` +
			`<path fill="${VIDRO}" d="M28.4 16.8C29.6 12.6 32 11.4 32 11.4s2.4 1.2 3.6 5.4Z"/>` +
			`<path stroke="#fff" stroke-width="5.2" stroke-linecap="round" d="M15.5 21.2h33"/>` +
			`<path stroke="${COR}" stroke-width="3.1" stroke-linecap="round" d="M15.5 21.2h33"/>` +
			`<circle cx="14.4" cy="21.2" r="2.3" fill="${COR}" stroke="#fff" stroke-width="1.4"/>` +
			`<circle cx="49.6" cy="21.2" r="2.3" fill="${COR}" stroke="#fff" stroke-width="1.4"/>` +
			(bau
				? `<rect x="21.5" y="36.5" width="21" height="15.5" rx="2.4" fill="${COR}" stroke="#fff" stroke-width="2.2"/>` +
					`<path stroke="${VIDRO}" stroke-width="1.6" d="M26 41.2h12M26 45.6h12"/>`
				: "") +
			(taxi
				? `<rect x="27.5" y="28.5" width="9" height="7" rx="1.4" fill="${VIDRO}" stroke="#fff" stroke-width="1.2"/>`
				: "")
	)
}

function bike() {
	return svg(
		`<circle cx="32" cy="51" r="9.2" fill="none" stroke="#fff" stroke-width="5"/>` +
			`<circle cx="32" cy="51" r="9.2" fill="none" stroke="${COR}" stroke-width="2.6"/>` +
			`<circle cx="32" cy="14.5" r="8.2" fill="none" stroke="#fff" stroke-width="5"/>` +
			`<circle cx="32" cy="14.5" r="8.2" fill="none" stroke="${COR}" stroke-width="2.6"/>` +
			`<path fill="none" stroke="#fff" stroke-width="4.2" stroke-linejoin="round" stroke-linecap="round" ` +
			`d="M32 14.5V28.5L25.2 48.5M32 28.5l6.8 20M25.2 48.5h13.6"/>` +
			`<path fill="none" stroke="${COR}" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round" ` +
			`d="M32 14.5V28.5L25.2 48.5M32 28.5l6.8 20M25.2 48.5h13.6"/>` +
			`<path stroke="#fff" stroke-width="4.6" stroke-linecap="round" d="M18 20.5h28"/>` +
			`<path stroke="${COR}" stroke-width="2.6" stroke-linecap="round" d="M18 20.5h28"/>`
	)
}

function sedan({ taxi = false } = {}) {
	return svg(
		rodaCarro(13.2, 16.2) +
			rodaCarro(45.6, 16.2) +
			rodaCarro(13.2, 37.8) +
			rodaCarro(45.6, 37.8) +
			`<rect x="18" y="7.5" width="28" height="49" rx="10" fill="${COR}" stroke="#fff" stroke-width="2.5"/>` +
			`<path fill="${VIDRO}" d="M23.2 15.2h17.6l-2.2 10.2H25.4Z"/>` +
			`<rect x="23.6" y="26.4" width="16.8" height="12.4" rx="1.6" fill="#0d47a1"/>` +
			`<rect x="24.4" y="41.6" width="15.2" height="7.2" rx="1.4" fill="${VIDRO_TRAS}"/>` +
			`<rect x="22.2" y="8.6" width="6.4" height="2.6" rx="1" fill="#fff"/>` +
			`<rect x="35.4" y="8.6" width="6.4" height="2.6" rx="1" fill="#fff"/>` +
			(taxi
				? `<rect x="25.5" y="4.2" width="13" height="5.4" rx="1.2" fill="#f5c518" stroke="#fff" stroke-width="1.4"/>`
				: "")
	)
}

function vanBox({ pickup = false } = {}) {
	return svg(
		rodaCarro(12.8, 16) +
			rodaCarro(46, 16) +
			rodaCarro(12.8, 38.4) +
			rodaCarro(46, 38.4) +
			`<rect x="17.4" y="7" width="29.2" height="50" rx="7.5" fill="${COR}" stroke="#fff" stroke-width="2.5"/>` +
			`<path fill="${VIDRO}" d="M22.6 12.4h18.8l-1.6 9.6H24.2Z"/>` +
			(pickup
				? `<rect x="20.4" y="28.5" width="23.2" height="24.2" rx="2" fill="#1565c0" stroke="#fff" stroke-width="1.6"/>`
				: `<rect x="21.4" y="23.8" width="21.2" height="27.4" rx="2" fill="#0d47a1"/>`) +
			`<rect x="21.8" y="8.2" width="6.2" height="2.5" rx="1" fill="#fff"/>` +
			`<rect x="36" y="8.2" width="6.2" height="2.5" rx="1" fill="#fff"/>`
	)
}

function caminhao() {
	return svg(
		rodaCarro(12.6, 14.5) +
			rodaCarro(46.2, 14.5) +
			rodaCarro(12.6, 32) +
			rodaCarro(46.2, 32) +
			rodaCarro(12.6, 44.5) +
			rodaCarro(46.2, 44.5) +
			`<rect x="18.2" y="6.5" width="27.6" height="20.5" rx="6.5" fill="${COR}" stroke="#fff" stroke-width="2.4"/>` +
			`<path fill="${VIDRO}" d="M23 11.2h18l-1.4 8.2H24.4Z"/>` +
			`<rect x="17" y="25.5" width="30" height="32.2" rx="2.4" fill="${COR}" stroke="#fff" stroke-width="2.4"/>` +
			`<rect x="21.2" y="29.4" width="21.6" height="24.2" rx="1.4" fill="#0d47a1"/>` +
			`<rect x="22" y="7.6" width="6" height="2.4" rx="1" fill="#fff"/>` +
			`<rect x="36" y="7.6" width="6" height="2.4" rx="1" fill="#fff"/>`
	)
}

function guincho() {
	return svg(
		rodaCarro(12.8, 16.5) +
			rodaCarro(46, 16.5) +
			rodaCarro(12.8, 39) +
			rodaCarro(46, 39) +
			`<rect x="18" y="7.2" width="28" height="22" rx="6.2" fill="${COR}" stroke="#fff" stroke-width="2.4"/>` +
			`<path fill="${VIDRO}" d="M23 12h18l-1.5 8.4H24.5Z"/>` +
			`<rect x="19.5" y="28" width="25" height="27.5" rx="2.2" fill="${COR}" stroke="#fff" stroke-width="2.3"/>` +
			`<path fill="#fff" stroke="#fff" stroke-width="2.4" stroke-linecap="round" d="M32 31.5v22"/>` +
			`<path fill="none" stroke="#fff" stroke-width="3.2" stroke-linecap="round" d="M32 34.5 L46 20.5"/>` +
			`<path fill="none" stroke="${COR}" stroke-width="1.8" stroke-linecap="round" d="M32 34.5 L46 20.5"/>` +
			`<rect x="22" y="8.4" width="6" height="2.4" rx="1" fill="#fff"/>` +
			`<rect x="36" y="8.4" width="6" height="2.4" rx="1" fill="#fff"/>`
	)
}

function aereo() {
	return svg(
		`<path fill="${COR}" stroke="#fff" stroke-width="2.4" stroke-linejoin="round" ` +
			`d="M32 6.5 L36.2 24.5 H54 L38.6 34.2 43.2 54.5 32 45.6 20.8 54.5 25.4 34.2 10 24.5 h17.8Z"/>` +
			`<ellipse cx="32" cy="20.5" rx="3.4" ry="5.2" fill="${VIDRO}"/>`
	)
}

function fluvial() {
	return svg(
		`<path fill="${COR}" stroke="#fff" stroke-width="2.5" stroke-linejoin="round" ` +
			`d="M32 6.8c8.4 9.6 14.6 22.4 14.6 36.4 0 6.4-6.4 11.2-14.6 11.2S17.4 49.6 17.4 43.2C17.4 29.2 23.6 16.4 32 6.8z"/>` +
			`<path fill="${VIDRO}" d="M27.6 16.5h8.8l-1.4 10.5h-6Z"/>` +
			`<rect x="25.5" y="29.5" width="13" height="16" rx="1.6" fill="#0d47a1"/>`
	)
}

const GLIFOS = {
	motoboy: moto({ bau: true }),
	"motoboy sem bau": moto(),
	mototaxi: moto({ taxi: true }),
	bikeboy: bike(),
	carro: sedan(),
	taxi: sedan({ taxi: true }),
	van: vanBox(),
	frete: vanBox(),
	utilitario: vanBox(),
	"utilitario sem bau": vanBox({ pickup: true }),
	caminhao: caminhao(),
	guincho: guincho(),
	aereo: aereo(),
	fluvial: fluvial(),
}

/** Veículo visto de cima, girando com o heading (0 = norte). Só a coluna tipoVeiculo.icone. */
export function htmlIconeGps(heading, arquivo) {
	const chave = chaveIconeRastreio(arquivo)
	const inner = chave ? GLIFOS[chave] : null
	if (!inner) return null
	const h = Number(heading) || 0
	return `<div class="rs-gps-dir"><div class="rs-gps-rot" style="transform:rotate(${h}deg)">${inner}</div></div>`
}
